var map = {
	"./bitharvest/DigitalAssets.vue": [
		"8f0e",
		"chunk-ebab8cf0",
		"chunk-feb86fe8",
		"chunk-3b906b38",
		"chunk-28028f36"
	],
	"./oripay/DigitalAssets.vue": [
		"b399",
		"chunk-ebab8cf0",
		"chunk-feb86fe8",
		"chunk-3b906b38",
		"chunk-7256cd47",
		"chunk-102297f1"
	],
	"./touareg/DigitalAssets.vue": [
		"54ff",
		"chunk-ebab8cf0",
		"chunk-feb86fe8",
		"chunk-3b906b38",
		"chunk-7256cd47",
		"chunk-103d190b"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "eddf";
module.exports = webpackAsyncContext;